import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "metadata-title",
  style: {"font-weight":"600","font-size":"17px"}
}, " Project Metadata ", -1)
const _hoisted_2 = { class: "module" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "module-title",
  style: {"font-weight":"600","font-size":"17px"}
}, " Project Module ", -1)
const _hoisted_4 = {
  key: 0,
  class: "generate-dao"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "generate-dao-title",
  style: {"font-weight":"600","font-size":"17px"}
}, " Generate Dao ", -1)

import {
  NForm,
  NFormItem,
  NInput,
  NDivider,
  NGrid,
  NGi,
  NGridItem,
  NRadioGroup,
  NRadio,
  NCollapse,
  NCollapseItem,
  NEl,
  NSelect,
} from "naive-ui";
import AppTypeCard from "@/components/appTypeCard/index.vue";
import ProjectModule from "@/components/projectModule/index.vue";
import GenerateDao from "./config/db.vue";
import { useMainStore } from "@/store/main";
import { computed, ref } from "vue";
import type { Ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useMainStore();
store.getAppType();
store.getAllDomain();
const gridRef = ref(null);
const showBorder = computed(() => {
  return {};
});
const rules = {
  groupId: {
    required: true,
    message: "必填项",
    trigger: "blur",
  },
  artifactId: {
    required: true,
    message: "必填项",
    trigger: "blur",
  },
  basePackage: {
    required: true,
    message: "必填项",
    trigger: "blur",
  },
  domain: {
    code: {
      required: true,
      message: "必填项",
      trigger: "blur",
    },
  },
  templateName: {
    required: true,
    message: "必填项",
    trigger: "blur",
  },
  grailFrameworkVersion: {
    required: true,
    message: "必填项",
    trigger: "blur",
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NGrid), {
    cols: "1 700:2",
    "x-gap": "15",
    ref_key: "gridRef",
    ref: gridRef
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGridItem), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NEl), {
            tag: "div",
            class: _normalizeClass(["metadata", _ctx.$style.metadata]),
            style: _normalizeStyle([{"border-right":"1px solid var(--border-color)"}, _unref(showBorder)])
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_unref(NDivider)),
              _createElementVNode("div", null, [
                _createVNode(_unref(NForm), {
                  "label-width": "120",
                  "label-placement": "left",
                  model: _unref(store).form,
                  rules: rules,
                  ref: (ref) => (_unref(store).formRef = ref)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NFormItem), {
                      label: "Group ID",
                      path: "groupId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: _unref(store).groupId,
                          onUpdateValue: _unref(store).updateGroupId,
                          placeholder: "com.itgrail.grail"
                        }, null, 8, ["value", "onUpdateValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "Artifact ID",
                      path: "artifactId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: _unref(store).artifactId,
                          placeholder: "grail.demo",
                          onUpdateValue: _unref(store).updateArtifactId
                        }, null, 8, ["value", "onUpdateValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "Package Name",
                      path: "basePackage"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: _unref(store).basePackage,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).basePackage) = $event)),
                          placeholder: "com.itgrail.grail.demo"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "Domain Name",
                      path: "domain.code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NSelect), {
                          value: _unref(store).domainValue,
                          onUpdateValue: _unref(store).updateDomainValue,
                          options: _unref(store).domains
                        }, null, 8, ["value", "onUpdateValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "App Type",
                      path: "templateName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NRadioGroup), {
                          value: _unref(store).templateName,
                          style: {"width":"100%"},
                          onUpdateValue: _unref(store).updateTemplateName
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NCollapse), { "default-expanded-names": ['1'] }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NCollapseItem), {
                                  title: "待选择应用类型",
                                  name: "1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NEl), {
                                      tag: "div",
                                      class: _normalizeClass(_ctx.$style['app-type-list'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NGrid), {
                                          "x-gap": "8",
                                          "y-gap": "8",
                                          cols: "1 300:2 600:3"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).appTypes, (item) => {
                                              return (_openBlock(), _createBlock(_unref(NGridItem), {
                                                key: item.appTypeValue
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(AppTypeCard, {
                                                    title: item.appTypeName,
                                                    desc: item.desc,
                                                    "min-height": 150
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(NRadio), {
                                                        value: item.appTypeValue
                                                      }, null, 8, ["value"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["title", "desc"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["class"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "onUpdateValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "Grail Version",
                      path: "grailFrameworkVersion"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NRadioGroup), {
                          value: _unref(store).versionValue,
                          onUpdateValue: _unref(store).updateVersionValue,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NGrid), {
                              cols: "1 s:2 m:3 l:4",
                              "x-gap": "8",
                              "y-gap": "8"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).versions, (item) => {
                                  return (_openBlock(), _createBlock(_unref(NGi), {
                                    key: item.grailFrameworkVersion
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NRadio), {
                                        value: item.grailFrameworkVersion
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.grailFrameworkVersion), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "onUpdateValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NFormItem), {
                      label: "Description",
                      path: "description"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: _unref(store).description,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).description) = $event)),
                          placeholder: "请输入描述",
                          type: "textarea"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          }, 8, ["class", "style"])
        ]),
        _: 1
      }),
      _createVNode(_unref(NGridItem), null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(NDivider)),
            _createElementVNode("div", null, [
              _createVNode(ProjectModule, {
                data: _unref(store).modelsData,
                "artifact-id": _unref(store).artifactId,
                value: _unref(store).models,
                onChange: _unref(store).updateModel
              }, null, 8, ["data", "artifact-id", "value", "onChange"])
            ])
          ], 512), [
            [_vShow, _unref(store).step === 'basis']
          ]),
          (_unref(store).step === 'db')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_unref(NDivider)),
                _createElementVNode("div", null, [
                  _createVNode(GenerateDao)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})